import { Injectable, inject } from '@angular/core';
import { EmployeeService } from '@coin/shared/auth/data-access';
import { UserState } from '@coin/shared/auth/feature';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MeritAllocationImpersonatedEmployeeService {
  private userState = inject(UserState);
  private employeeService = inject(EmployeeService);

  public employeeId: string;

  public getEmployeeIdQuery(prefix = '&'): string {
    return this.employeeId ? `${prefix}impersonatedEmployee=${encodeURIComponent(this.employeeId)}` : '';
  }

  public getGid(): Observable<string> {
    if (!this.employeeId) {
      return this.userState.user$.pipe(
        take(1),
        map(user => user?.gid)
      );
    }

    return this.employeeService.getEmployeeDetails(this.employeeId).pipe(map(employee => employee?.gid));
  }
}
